import useCurrentProfile from './useCurrentProfile';

const useIsSendMoneyAvailable = () => {
  const profile = useCurrentProfile();
  const hasFeature = profile?.features?.veengu_direct_transfer;
  return hasFeature;
};

export default useIsSendMoneyAvailable;
